import { NavLink } from 'react-router-dom';
import { mobileNavigationItems } from './navigation';

/**
 * Bottom navigation of the mobile CMS. Fixed above the home indicator
 * (safe-area inset); the shell pads its content by the same height.
 */
export function MobileTabBar() {
	return (
		<nav
			aria-label="Main"
			className="bg-background fixed inset-x-0 bottom-0 z-40 border-t pr-[env(safe-area-inset-right)] pb-[env(safe-area-inset-bottom)] pl-[env(safe-area-inset-left)]"
		>
			<ul className="grid h-16 auto-cols-fr grid-flow-col">
				{mobileNavigationItems.map(({ label, to, icon: Icon }) => (
					<li key={to} className="flex">
						<NavLink
							to={to}
							className="text-muted-foreground aria-[current=page]:text-primary focus-visible:ring-ring/50 flex flex-1 flex-col items-center justify-center gap-1 text-xs font-medium transition-colors outline-none focus-visible:ring-[3px]"
						>
							<Icon className="size-5" aria-hidden="true" />
							<span className="truncate">{label}</span>
						</NavLink>
					</li>
				))}
			</ul>
		</nav>
	);
}
